import { Target, TrendingUp, Award } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Progress } from '@/components/ui/progress'
import { Loading } from '@/components/ui/loading'
import { usePerformanceStats, usePerformanceReviews } from '@/hooks'

export function PerformancePage() {
  const { data: statsData, isLoading: isStatsLoading } = usePerformanceStats()
  const { data: reviewsData, isLoading: isReviewsLoading } = usePerformanceReviews()

  const isLoading = isStatsLoading || isReviewsLoading

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
              <Target className="w-6 h-6 text-purple-500" />
              绩效管理
            </h1>
            <p className="text-slate-500 dark:text-slate-400 mt-1">
              KPI 设置、绩效评估和历史记录
            </p>
          </div>
        </div>
        <Loading className="py-20" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <Target className="w-6 h-6 text-purple-500" />
            绩效管理
          </h1>
          <p className="text-slate-500 dark:text-slate-400 mt-1">
            KPI 设置、绩效评估和历史记录
          </p>
        </div>
        <Button>发起评估</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <Award className="w-5 h-5 text-yellow-500" />
              <span className="text-sm text-slate-500">本季度评分</span>
            </div>
            <div className="text-3xl font-bold text-slate-900 dark:text-white mt-2">92</div>
            <Progress value={92} className="mt-2" />
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <TrendingUp className="w-5 h-5 text-green-500" />
              <span className="text-sm text-slate-500">同比上季度</span>
            </div>
            <div className="text-3xl font-bold text-green-600 mt-2">+5%</div>
            <p className="text-sm text-slate-400 mt-2">较上季度提升</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center gap-2">
              <Target className="w-5 h-5 text-indigo-500" />
              <span className="text-sm text-slate-500">KPI 完成率</span>
            </div>
            <div className="text-3xl font-bold text-indigo-600 mt-2">95%</div>
            <Progress value={95} className="mt-2" />
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>绩效评估历史</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {['2024 Q1', '2023 Q4', '2023 Q3'].map((quarter) => (
              <div
                key={quarter}
                className="flex items-center justify-between p-4 rounded-lg border border-slate-200 dark:border-slate-800"
              >
                <div>
                  <p className="font-medium text-slate-900 dark:text-white">{quarter}</p>
                  <p className="text-sm text-slate-500">季度绩效评估</p>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-slate-900 dark:text-white">90</p>
                  <p className="text-sm text-green-600">优秀</p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
